import { render } from "./check-tariff.vue?vue&type=template&id=e637ef50&scoped=true&ts=true"
import script from "./check-tariff.vue?vue&type=script&lang=ts"
export * from "./check-tariff.vue?vue&type=script&lang=ts"

import "./check-tariff.vue?vue&type=style&index=0&id=e637ef50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e637ef50"]])

export default __exports__